class SerpArticleList {
  constructor($el) {
    this.$el = $el;

    this.initEvents();
  }

  initEvents() {
    this.$moreWrapper = this.$el.querySelector('.serp-article-list__button-wrap');
    this.$moreButton = this.$moreWrapper && this.$moreWrapper.querySelector('button');

    if (this.$moreButton) {
      this.$moreButton.addEventListener('click', () => this.loadMore());
    }
  }

  loadMore() {
    this.get(this.$moreWrapper.dataset.moreUrl, (response) => {
      const $content = this.$el.querySelector(`#${this.$moreWrapper.dataset.contentId}`);
      const $contentMoreButton = $content.querySelector('.serp-article-list__button-wrap');

      $contentMoreButton.remove();

      const parser = new DOMParser();
      const document = parser.parseFromString(response, 'text/html');
      const $listItems = document.body.querySelector(`#${this.$moreWrapper.dataset.contentId}`);

      $content.append(...$listItems.childNodes);

      this.initEvents();
    });
  }

  get(url, successCallback) {
    this.req = new XMLHttpRequest();
    this.req.open('get', url);
    this.req.onload = () => {
      if (this.req.status === 200) successCallback(this.req.response);
      else Error(this.req.statusText);
    };

    this.req.send();
  }

  createElementFromHTML(html) {
    const div = document.createElement('div');
    div.innerHTML = html.trim();

    return div.childNodes;
  }
}

document.querySelectorAll('.js-serp-article-list').forEach($el => new SerpArticleList($el));
